import { yellow } from "@material-ui/core/colors";
import styled from "styled-components";

export const Image = styled("img")`
width:150px;
height:35px;
position: relative;
top:52px;
left:130px;
@media (max-width: 768px) {
    top: auto;
    left: auto;
} 
@media (min-width: 769px) and (max-width: 1360px) {
    top: auto;
    left: auto;
} 
`;

export const Image1 = styled("img")`
    width: 50px;
    object-fit: contain;
    position: fixed;
    top: 32px;
    left: 30px; 
    @media (max-width:990px){
        display:none;
    }
`;
export const ImagePharmacyLogo = styled("img")`
    width: 100px;
    object-fit: contain;
    position: fixed;
    top: 32px;
    left: 9px;
    mix-blend-mode: multiply;
`;


export const Image2 = styled("img")`
width:37px;
object-fit:contain;
margin-top:-17px;
`;

